import { render, staticRenderFns } from "./AssetSetup.vue?vue&type=template&id=325f738f&scoped=true"
import script from "./AssetSetup.vue?vue&type=script&lang=ts"
export * from "./AssetSetup.vue?vue&type=script&lang=ts"
import style0 from "./AssetSetup.vue?vue&type=style&index=0&id=325f738f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325f738f",
  null
  
)

export default component.exports